<template>
  <div class="iptNumberBtn__div">
    <a-input-number
        v-bind="$attrs"
        :id="idIpt"
        @change="iptChange"
        :min="min"
        :max="max"/>
    <el-button type="primary" @click="clickCall">
      {{text}}
    </el-button>
  </div>
</template>

<script>
import {InputNumber} from "ant-design-vue";
import 'ant-design-vue/lib/input-number/style/css';
export default {
  name: "IptNumberBtn",
  components: {
    [InputNumber.name]: InputNumber
  },
  props: {
    text: {
      type: String,
      default: _=> '确定'
    },
    min: {
      type: Number,
      default: _=> 0
    },
    max: {
      type: Number,
      default: _=> 10000
    }
  },
  data () {
    return {
      val: '',
      idIpt: Math.random().toFixed(8)
    }
  },
  methods: {
    iptChange: function (val) {
      this.val = val
      this.$emit('input', val)
      this.$emit('change', val)
    },
    clickCall: function () {
      this.$emit('click', this.val)
    }
  }
}
</script>

<style scoped>
.iptNumberBtn__div {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
::v-deep .ant-input-number {
  width: 100px;
  position: relative;
  top: 0;
  left: 0;
  border-radius: 4px 0 0 4px;
}

::v-deep .el-button ,::v-deep .el-button--mini,::v-deep  .el-button--small{
  border-radius: 0 4px 4px 0;
}

::v-deep .ant-input-number-focused {
  border-right-color: transparent;
}
::v-deep .ant-input-number-focused::before{
  border-color: #40a9ff;
  border-left-color: transparent;
  box-shadow: 2px 0 2px 2px rgba(64, 169, 255, 0.25);
}
::v-deep .ant-input-number-focused + .el-button{
  border-color: #40a9ff;
  box-shadow: 2px 0 2px 2px rgba(64, 169, 255, 0.25);
}
</style>